import { show, hide } from 'redux-modal'
import { ACTIVE_CART_REMINDER_MODAL } from 'constant'

export const showActiveCartReminderModal = ({ totalCount }) => dispatch => {
  dispatch(show(ACTIVE_CART_REMINDER_MODAL, { totalCount }))
}

export const hideActiveCartReminderModal = () => dispatch =>
  dispatch(hide(ACTIVE_CART_REMINDER_MODAL))
